var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdultsOnlyRisingPosition(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.92 21.26C32.593 21.26 34.76 19.093 34.76 16.42C34.76 13.7469 32.593 11.58 29.92 11.58C27.2469 11.58 25.08 13.7469 25.08 16.42C25.08 19.093 27.2469 21.26 29.92 21.26Z",
    fill: "#FF6AA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34 47.98C11.0131 47.98 13.18 45.8131 13.18 43.14C13.18 40.467 11.0131 38.3 8.34 38.3C5.66694 38.3 3.5 40.467 3.5 43.14C3.5 45.8131 5.66694 47.98 8.34 47.98Z",
    fill: "#00A6ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8199 39.5199C32.3599 41.4399 30.8599 43.5999 30.5799 45.8599C30.4999 46.3599 30.4799 46.8399 30.5399 47.2999C25.5199 47.0199 20.9599 47.0399 15.3999 48.0599C14.7199 48.2199 14.16 47.3999 14.54 46.8199C16.9799 42.8599 21.3199 40.8199 25.6599 39.8599C28.2799 39.2399 31.0999 39.2799 33.8199 39.5199Z",
    fill: "#00A6ED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.88 48.34C55.3 47.58 50.12 47.62 44.72 47.7C44.6 47.56 44.44 47.46 44.26 47.4C42.88 46.94 41.44 46.6 40.08 46.22C41.82 44.64 43.76 42.96 44.94 40.88C50.8 41.88 56.76 43.74 61.16 47.6C61.48 47.84 61.28 48.4 60.88 48.34Z",
    fill: "#00A6ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.92 48.62C44.86 48.88 44.68 49.08 44.46 49.2C42.78 49.96 41.06 50.5599 39.2 50.92C35.66 51.8799 30.78 50.68 31.36 46C31.84 42.84 34.54 40.26 36.28 37.8C30.58 34.28 30.36 25.58 35.12 21.12C35.38 20.86 35.86 21.04 35.88 21.4C36.96 26.28 37.08 29.72 40.82 31.24C41 31.34 44.24 32.22 44.98 35.64C45.7 40.62 41.48 43.48 38.64 46.36C40.44 46.86 42.4 47.12 44.3 47.6C44.76 47.72 45.04 48.18 44.92 48.62Z",
    fill: "#FF6AA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdultsOnlyRisingPosition);
export default __webpack_public_path__ + "static/media/adults_only_rising_position.094e6d2b4efe6b708593420e4b5c6d88.svg";
export { ForwardRef as ReactComponent };